<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <!--        <span class="headline">{{ title }}</span>-->
        <v-spacer/>
      </v-card-title>
      <v-card-text>
        <r-smart-offer-table :items="items" :title="title"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {SmartOffer} from "@/modules/redactor/models/smart-offer/core/SmartOffer";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RSmartOfferTable from "@/modules/redactor/views/smart-offer/r-smart-offer-table.vue";

export default {
  name: "r-smart-offer-table-dialog",
  components: {RSmartOfferTable},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    title: "Smart Offers",
    items: VueTypes.arrayOf(SmartOffer),
    rules: ViewRules.READONLY,
    dialogWidth: 633,
    dialogHeight: 520,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 633,
    resizeStartHeight: 520,
    viewportPadding: 32
  }),
  methods: {
    show(rules, items, title) {
      this.dialog = true;
      this.rules = rules;

      if (!items || items.length === 0) {
        this.items = [];
      } else if (items[0] instanceof SmartOffer) {
        this.items = items;
      } else {
        this.items = items.map(v => RedactorUtils.getSmartOffer(v));
      }

      this.title = title || "Smart Offers";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      this.resolve(this.items);
      this.discard();
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;

      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;

      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;

      const minWidth = 400;
      const minHeight = 250;

      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;

      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    this.stopResize();
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}

.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>